import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconsModule } from "@mk/med-icons";

import { MedCheckboxComponent } from "./med-checkbox.component";
import { MedLabelModule } from "../med-label/med-label.module";

@NgModule({
  declarations: [
    MedCheckboxComponent,
  ],
  imports: [
    CommonModule,
    MedIconsModule,
    MedLabelModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    MedCheckboxComponent,
  ],
})
export class MedCheckboxModule { }
